"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _progressStep = _interopRequireDefault(require("./progress-step"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
const ProgressTracker = _ref => {
  let {
    className,
    currentStepIndex,
    steps,
    element,
    stepIndexClassName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-label": "Progress Tracker"
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: (0, _classnames.default)(className, _indexModule.default.ProgressTracker)
  }, steps.map((step, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: "progress-step-".concat(index),
    className: (0, _classnames.default)({
      [_indexModule.default.notAllowed]: step.disabled && currentStepIndex !== index
    })
  }, /*#__PURE__*/_react.default.createElement(_progressStep.default, (0, _extends2.default)({
    isCurrent: currentStepIndex === index,
    element: element,
    stepIndexClassName: stepIndexClassName
  }, step))))));
};
var _default = exports.default = ProgressTracker;